export default __webpack_public_path__ + "static/media/Rabih-Barbar.c215a424.jpg";